// Entry point for the build script in your package.json
import Main from "./packs/Main";

window.app = new Main();
